import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Sidebar, Footer, Partners, Header, Help } from '../shared'
import Landing from './Landing'
import Content from './Content'


function Map() {
    const [showHelp, setShowHelp] = useState(false)
    const location = useLocation()
    return (
        <div className='page'>
            <Sidebar setShowHelp={setShowHelp} showHelp={showHelp} />
            <Header setShowHelp={setShowHelp} />
            <div className="page__main">
                {
                    showHelp &&
                    <Help
                        showModal={showHelp}
                        hideModal={() => setShowHelp(false)}
                    />
                }
                <Landing />
                <Content data={location.state}/>
                <Partners />
                <Footer />
            </div>
        </div>
    )
}

export default Map